import { useEffect, useRef, useState } from 'react'
import { useAtomValue } from 'jotai/react'

import BetSdkUtils from '@/lib/betSdkUtils'
import useSolana from '@/lib/solana/hooks/useSolana'
import {
  ProviderFactoryEvents,
  solanaProvider
} from '@/lib/solana/lib/providerFactory'
import { transactionSettingAtom } from '@/stores/settings'

export const useBetSdkUtils = () => {
  const { tradeProvider } = useSolana()

  const txSetting = useAtomValue(transactionSettingAtom)

  const [connection, setConnection] = useState(solanaProvider.connection)
  const betSdkUtilRef = useRef<BetSdkUtils>()

  useEffect(() => {
    betSdkUtilRef.current = new BetSdkUtils({
      txSetting: txSetting
    })
    // 监听rpc切换，重新初始化 BetSdkUtils
    const fnListener = () => {
      setConnection(solanaProvider.connection)
      betSdkUtilRef.current = new BetSdkUtils({
        txSetting: txSetting
      })
    }
    solanaProvider.event.on(ProviderFactoryEvents.ON_CHANGE, fnListener)

    return () => {
      betSdkUtilRef.current = undefined
      solanaProvider.event.off(ProviderFactoryEvents.ON_CHANGE, fnListener)
    }
  }, [])

  useEffect(() => {
    let provider
    if (tradeProvider) provider = tradeProvider
    betSdkUtilRef.current?.setProvider(provider)
  }, [tradeProvider])

  useEffect(() => {
    if (txSetting) {
      betSdkUtilRef.current?.setTxSetting(txSetting)
    }
  }, [txSetting])

  return {
    connectionState: connection,
    betSdkUtilRef: betSdkUtilRef,
    txSetting: txSetting
  }
}

export default useBetSdkUtils
